import SMSPage from '@/pages/order/sms'
import FrontOrder from '@/pages/order/front-order'
import OrderList from '@/pages/order/order-list'
import StopSheet from '@/pages/order/stop-sheet'
import PayOrder from '@/pages/order/pay-order'
import CreateOrder from '@/pages/order/create-order'
import Invoice from '@/pages/order/invoice'
import OrderResource from '@/pages/order/order-resource'
import Refunds from '@/pages/order/refunds-list'
import OwnerOrderList from '@/pages/order/owner-order-list'
import ShortRent from '@/pages/order/short-rent-list'
import ConsumptionList from '@/pages/order/consumption-list'
import OrderDetail from '@/pages/order/order_detail/order-detail'
import InvoiceManage from '@/pages/order/invoiceManage'
import ImportRecord from '@/pages/order/import-record'
import SupplementaryOrder from '@/pages/order/supplementary-order'
import LateCheckOutOrderList from "@/pages/order/late-check-out-order"
// 发票管理
export const invoiceManage = {
  path: 'order/invoiceManage',
  component: InvoiceManage
}
// 管理短信
export const sms = {
  path: 'order/sms',
  component: SMSPage
}

// 所有订单
export const orderList = {
  path: 'order/orderList',
  component: OrderList
}

// 前台下单
export const frontOrder = {
  path: 'order/frontOrder',
  component: FrontOrder
}

// 代下单
export const createOrder = {
  path: 'order/createOrder',
  component: CreateOrder
}

// 停用单管理
export const stopSheet = {
  path: 'order/roomStopSheetList',
  component: StopSheet
}

// 支付单报表
export const payOrder = {
  path: 'order/payOrder',
  component: PayOrder
}

// 发票管理
export const invoice = {
  path: 'order/invoice',
  component: Invoice
}

// 订单来源
export const orderResource = {
  path: 'order/resource',
  component: OrderResource
}

//退款单列表
export const refundsList = {
  path: 'order/refunds',
  component: Refunds
}

//自用单列表
export const ownerOrderList = {
  path: 'order/ownerOrder',
  component: OwnerOrderList
}

// 短租退款单列表
export const shortRent = {
  path: 'order/shortRent',
  component: ShortRent
}

//入账单列表
export const consumptionList = {
  path: 'order/consumptionList',
  component: ConsumptionList
}
//订单详情
export const OrderDetailNew = {
  path: 'order/orderDetail',
  component: OrderDetail
}

//批量修正金额导入记录
export const ImportRecordList = {
  path: 'order/import-record',
  component: ImportRecord
}

//补录订单记录
export const SupplementaryOrderList = {
  path: 'order/supplementary-order',
  component: SupplementaryOrder
}

// 延迟退房订单
export const LateCheckOutOrder = {
  path: 'order/late-check-out-order',
  component: LateCheckOutOrderList
}


// WEBPACK FOOTER //
// ./src/router/order.js